import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { FILTER_ENTITY_TYPES } from "@app/component/filtering/utils/consts";
import { getCombinedFilterDifferencesCount } from "@app/component/filtering/utils/getFilterDifferencesCount";
import CommonFieldName from "@app/util/fieldModel/CommonFieldName";

import { getCombinedConditionsCount } from "./getCombinedConditionsCount";

export const getMapFilterDifferencesCount = (
  filters1: MapFilterModel,
  filters2: MapFilterModel,
  excludeFields?: IField[]
): number => {
  const excludedFieldsFilterNames = new Set([
    CommonFieldName.VIEW_AS,
    ...(excludeFields ?? []).map(({ filterName }) => filterName),
  ]);

  return FILTER_ENTITY_TYPES.reduce((result, entityType) => {
    if (filters1[entityType] && filters2[entityType]) {
      return (
        result +
        getCombinedFilterDifferencesCount(
          filters1[entityType]!,
          filters2[entityType]!,
          excludedFieldsFilterNames
        )
      );
    } else if (filters1[entityType]) {
      return result + getCombinedConditionsCount(filters1[entityType]!, excludedFieldsFilterNames);
    } else if (filters2[entityType]) {
      return result + getCombinedConditionsCount(filters2[entityType]!, excludedFieldsFilterNames);
    }
    return result;
  }, 0);
};
